var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('site-title'),_c('span',{staticClass:"author-liner"},[_vm._v("by kam seng aung, joshua weitzel and sam tsao")]),_c('navigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }